import * as React from "react";
import { isEmpty } from 'lodash'
import { callApi } from "../../utils/api";
import { ADMIN_ROLE } from "../../utils/role";
import ReactFlexyTable from "react-flexy-table";
import "react-flexy-table/dist/index.css";
import AddBankPolicy from './AddBankPolicy';
import ExcelBankPolicyReport from './ExcelBankPolicyReport';

class ManageBankPolicy extends React.Component {
  state = {
    bankPolicyList: [],
    isAddEditBankPolicy: false,
    selectedBankPolicy: {},
    bankPolicyToDelete: {},
    bankList: [],
    policyList: [],
    productsList: [],
  };

  componentDidMount() {
    this.getBankPolicyList();
    this.getBankList();
    this.getPolicyList();
    this.listBankproduct();
  }

  getBankPolicyList = () => {
    callApi("GET", "bank_policy_get.php")
      .then(res => res.data)
      .then(response => {
        let bankPolicyList = response.data;
        bankPolicyList = bankPolicyList.map((list, index) => {
          return { ...list, index: index + 1 }
        })
        this.setState({ bankPolicyList });
      })
      .catch(err => {
        console.log(err);
      });
  };

  getBankList = () => {
    callApi("GET", "bank_get.php")
      .then(res => res.data)
      .then(response => {
        this.setState({ bankList: response.data });
      })
      .catch(err => {
        console.log(err);
      });
  };

  listBankproduct = () => {
    this.setState({ isFileRefresh: false });
    callApi("GET", "bank_product_get.php")
      .then(res => res.data)
      .then(response => {
        const files = response.data;
        this.setState({ productsList: files });
      })
      .catch(err => {
        console.log(err);
      });
  };

  getPolicyList = () => {
    callApi("GET", "policy_get.php")
      .then(res => res.data)
      .then(response => {
        let policyList = response.data;
        policyList = policyList.map((list, index) => {
          const { policy } = list;
          return { policy, index, policy_id: list.id }
        })
        this.setState({ policyList });
      })
      .catch(err => {
        console.log(err);
      });
  };

  addBankPolicy = () => {
    this.setState({ isAddEditBankPolicy: true });
  };

  editBankPolicy = (bankPolicy) => {
    this.setState({ selectedBankPolicy: bankPolicy, isAddEditBankPolicy: true });
  };

  confirmDeleteBankPolicy = (bankPolicy) => {
    this.setState({ bankPolicyToDelete: bankPolicy.id });
  };

  deleteBankPolicy = () => {
    callApi("POST", "bank_policy_delete.php", { id: this.state.bankPolicyToDelete })
      .then(res => res.data)
      .then(response => {
        this.getBankPolicyList();
      })
      .catch(err => {
        console.log(err);
      });
  };

  handleBack = () => {
    this.getBankPolicyList();
    this.setState({ isAddEditBankPolicy: false, selectedBankPolicy: {} })
  }

  render() {
    if (this.state.isAddEditBankPolicy) {
      const modifiedBankList = this.state.bankList
      // .filter(bank => {
      //   return !this.state.bankPolicyList.find(bankPolicy => bank.id === bankPolicy.bank_id)
      // })
      return <AddBankPolicy bankPolicy={this.state.selectedBankPolicy} bankList={modifiedBankList} productsList={this.state.productsList} onBack={this.handleBack} isEdit={!isEmpty(this.state.selectedBankPolicy)} policyList={this.state.policyList} />
    }
    const user = localStorage.getItem("user");
    const role_id = user ? JSON.parse(user)["role_id"] : "";
    const columns = [
      {
        header: 'S.No',
        key: 'index',
      },
      {
        header: 'Bank Name',
        key: 'bank_name',
        td: row => (
          <span title={row.bank_name}>
            {row.bank_name
              ? <>
                {row.bank_name} {row.product_name ? `(${row.product_name})` : ''}
              </>
              : '—'}
          </span>
        )
      },
      {
        header: "Actions",
        td: (bankPolicy) => {
          return <div className="btn-group mb-2 mr-2">
            <button
              type="button"
              className="btn btn-primary"
            >
              Action
            </button>
            <button
              type="button"
              className="btn btn-primary dropdown-toggle dropdown-toggle-split"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <span className="sr-only">
                Toggle Dropdown
              </span>
            </button>
            <div
              className="dropdown-menu"
              x-placement="top-start"
              style={{
                position: "absolute",
                top: "0px",
                left: "0px",
                transform:
                  "translate3d(88px, -2px, 0px)"
              }}
            >
              <button
                className="dropdown-item"
                data-toggle="modal"
                data-target="#policy-form"
                onClick={() =>
                  this.editBankPolicy(bankPolicy)
                }
              >
                Edit
              </button>
              {role_id === ADMIN_ROLE && (
                <button
                  className="dropdown-item"
                  style={{ float: "right" }}
                  data-toggle="modal"
                  data-target="#delete-policy"
                  onClick={() =>
                    this.confirmDeleteBankPolicy(bankPolicy)
                  }
                >
                  Delete
                </button>
              )}
            </div>
          </div>
        }
      }
    ];
    const data = this.state.bankPolicyList;
    return (
      <section className="policymain-container">
        <div className="pcoded-wrapper">
          <div className="pcoded-content">
            <div className="pcoded-inner-content">
              <div className="main-body">
                <div className="page-wrapper">
                  <div className="card">
                    <div className="card-header policy-header">
                      <h5>Bank Policy Manage</h5>
                    </div>
                    <div className="card-body">
                      <div className="dt-responsive table-responsive">
                        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '20px' }}>
                          <button
                            className="btn btn-primary"
                            data-toggle="modal"
                            data-target="#policy-form"
                            onClick={this.addBankPolicy}
                          >
                            + Add Bank Policy
                          </button>
                          {data && data.length > 0 && <ExcelBankPolicyReport data={this.state.bankPolicyList} />}
                        </div>
                        <ReactFlexyTable data={data} columns={columns} sortable globalSearch />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="modal fade"
          id="delete-policy"
          role="dialog"
          aria-hidden="true"
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Delete Bank Policy</h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <h6>Are you sure you want to delete this bank policy?</h6>
                <div className="form-group">
                  {/* <label>Reason</label> */}
                  {/* <textarea
                    name="reason"
                    className="form-control"
                    onChange={e => this.handleChange(e)}
                    value={this.state.reason}
                    placeholder="Reason"
                  /> */}
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  data-dismiss="modal"
                  onClick={this.deleteBankPolicy}
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}
export default ManageBankPolicy;
